import React, { useEffect, useState } from "react";
import {
	Button,
	Col,
	Form,
	Modal,
	Pagination,
	Row,
	Spinner,
	Table,
	Toast,
} from "react-bootstrap";
import { connect } from "react-redux";
import styled from "styled-components";
import { AddCircle, Delete, Edit } from "@material-ui/icons";
import { getAllAdminAppVersions } from "../../store/actions/dashboardAction";
import API from "../../network/dashboardAPI";

const AppVersions = (props) => {
	const [id, setId] = useState(null);
	const [version, setVersion] = useState("");
	const [selectedOS, setSelectedOS] = useState("");

	const [filters, setFilters] = useState({
		os: "",
		status: "",
		page: 1,
		limit: 10,
	});

	const [showModal, setShowModal] = useState(false);
	const [modalMode, setModalMode] = useState(""); // create || edit

	// Toast Message
	const [showToast, setShowToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [toastBgColor, setToastBgColor] = useState("bg-success");

	const osOptions = [
		{ id: 0, label: "All OS", value: "" },
		{ id: 1, label: "Android", value: "Android" },
		{ id: 2, label: "IOS", value: "IOS" },
	];

	const statusOptions = [
		{ id: 0, label: "All Versions", value: "" },
		{ id: 1, label: "Current Version(s)", value: 0 },
		{ id: 2, label: "Previous Version(s)", value: 1 },
	];

	const limitOptions = [
		{ id: 0, label: "10", value: 10 },
		{ id: 1, label: "20", value: 20 },
		{ id: 2, label: "30", value: 30 },
		{ id: 3, label: "40", value: 40 },
		{ id: 4, label: "50", value: 50 },
	];

	const body = {
		os: filters.os,
		is_deleted: filters.status,
		page: filters.page,
		limit: filters.limit,
	};

	const handleShowToast = (type = "", msg = "") => {
		setShowToast(true);
		setToastMessage(msg);
		switch (type) {
			case "success":
				setToastBgColor("bg-success");
				break;
			case "fail":
				setToastBgColor("bg-danger");
				break;
			default:
				break;
		}
	};

	const handleChangeFilters = (type, e = "", target = "") => {
		switch (type) {
			case "os":
				setFilters({
					...filters,
					os: e.target.value,
				});
				break;
			case "status":
				setFilters({
					...filters,
					status: parseInt(e.target.value),
				});
				break;
			case "limit":
				setFilters({
					...filters,
					page: 1,
					limit: parseInt(e.target.value),
				});
				break;
			case "page":
				switch (target) {
					case "first":
						if (filters.page === 1) return;
						setFilters({
							...filters,
							page: 1,
						});
						break;
					case "back":
						if (filters.page === 1) return;
						setFilters({
							...filters,
							page: filters.page - 1,
						});
						break;
					case "next":
						if (filters.page === props?.app_versions?.totalPages) return;
						setFilters({
							...filters,
							page: filters.page + 1,
						});
						break;
					case "last":
						if (filters.page === props?.app_versions?.totalPages) return;
						setFilters({
							...filters,
							page: props?.app_versions?.totalPages,
						});
						break;
					default:
						break;
				}
				break;
			default:
				break;
		}
	};

	const handleChangeSelectedOS = (e) => {
		setSelectedOS(e.target.value);
	};

	const handleChangeVersion = (e) => {
		setVersion(e.target.value);
	};

	const handleShowCloseModal = (mode, data = {}) => {
		setShowModal((prev) => !prev);
		setModalMode(mode);
		switch (mode) {
			case "create":
				setSelectedOS("Android");
				break;
			case "edit":
				setId(data?.id);
				setSelectedOS(data?.os);
				setVersion(data?.version);
				break;
			default:
				setSelectedOS("");
				setVersion("");
				break;
		}
	};

	const handleSubmitCreateEdit = (e) => {
		e.preventDefault();
		if (!selectedOS) return handleShowToast("fail", "OS is required.");
		if (!version) return handleShowToast("fail", "Version is required.");
		switch (modalMode) {
			case "create":
				API.createAdminNewAppVersion({ os: selectedOS, version })
					.then((res) => res.json())
					.then((res) => {
						if (res?.success) {
							props.getAllAdminAppVersions(body);
							handleShowCloseModal("");
							handleShowToast("success", "Created Successfully.");
						} else {
							handleShowToast("fail", res.message);
						}
					});
				break;
			case "edit":
				API.updateAdminAppVersion({ appId: id, os: selectedOS, version })
					.then((res) => res.json())
					.then((res) => {
						if (res?.success) {
							props.getAllAdminAppVersions(body);
							handleShowCloseModal("");
							handleShowToast("success", "Updated Successfully.");
						} else {
							handleShowToast("fail", res.message);
						}
					});
				break;
			default:
				break;
		}
	};

	const handleDeleteAppVersion = (appId) => {
		if (!window.confirm("Are you sure you want to delete this version?")) return;
		API.deleteAdminAppVersion({ appId })
			.then((res) => res.json())
			.then((res) => {
				if (res.success) {
					props.getAllAdminAppVersions(body);
					handleShowToast("success", "Deleted Successfully.");
				} else {
					handleShowToast("fail", res.message);
				}
			});
	};

	useEffect(() => {
		props.getAllAdminAppVersions(body);
	}, [filters.os, filters.status, filters.limit, filters.page]);

	return (
		<HelpPageWrapper>
			<CardContainer>
				<Row>
					<Col xs={12} md={6}>
						<h4 className="mb-4">App Versions</h4>
					</Col>
					<Col xs={12}>
						<Row>
							<Col xs={12} md={6} lg={3}>
								<Form.Group controlId="formFilterOS">
									<Form.Control
										as="select"
										onChange={(e) => handleChangeFilters("os", e, "")}
									>
										{osOptions.map((os) => {
											return (
												<option key={os.id} value={os.value}>
													{os.label}
												</option>
											);
										})}
									</Form.Control>
								</Form.Group>
							</Col>
							<Col xs={12} md={6} lg={3}>
								<Form.Group controlId="formFilterStatus">
									<Form.Control
										as="select"
										onChange={(e) => handleChangeFilters("status", e, "")}
									>
										{statusOptions.map((status) => {
											return (
												<option key={status.id} value={status.value}>
													{status.label}
												</option>
											);
										})}
									</Form.Control>
								</Form.Group>
							</Col>
							<Col xs={12} lg={6}>
								<Button
									onClick={() => handleShowCloseModal("create")}
									className="d-block ml-auto mb-2"
								>
									<AddCircle /> New Version
								</Button>
							</Col>
						</Row>
					</Col>
				</Row>
				<TableBodyWidth>
					<Table striped bordered hover responsive>
						<thead>
							<tr>
								<th>OS</th>
								<th>Version</th>
								<th>Release Date</th>
								<th>Status</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{props?.app_versions.list?.length ? (
								props?.app_versions?.list?.map((item) => {
									return (
										<tr key={item?.id}>
											<td>{item?.os}</td>
											<td>{item?.version}</td>
											<td>{item?.createdAt}</td>
											<td>
												{item?.is_deleted ? (
													<p className="h-100 w-100 d-flex justify-content-center  align-items-center bg-danger text-white rounded px-1">
														Previous
													</p>
												) : (
													<p className="h-100 w-100 d-flex justify-content-center align-items-center bg-success text-white rounded px-1">
														Current
													</p>
												)}
											</td>
											<td className="d-flex" style={{ gap: "0.25rem" }}>
												<Button
													size="sm"
													variant={item?.is_deleted ? "secondary" : "info"}
													disabled={item?.is_deleted}
													className="w-100"
													onClick={() => handleShowCloseModal("edit", item)}
												>
													<Edit />
												</Button>
												<Button
													size="sm"
													variant={!item?.is_deleted ? "secondary" : "danger"}
													disabled={!item?.is_deleted}
													className="w-100"
													onClick={() => handleDeleteAppVersion(item.id)}
												>
													<Delete />
												</Button>
											</td>
										</tr>
									);
								})
							) : props?.loading ? (
								<tr>
									<td colSpan={6} className="text-center">
										<Spinner animation="border" variant="secondary" />
									</td>
								</tr>
							) : (
								<tr>
									<td colSpan={6} className="text-center">
										No Data
									</td>
								</tr>
							)}
						</tbody>
					</Table>
					<Row>
						<Col xs={12} sm={3}>
							<div className="d-flex align-items-center">
								<p className="mr-1">Items:</p>
								<p>{props.app_versions?.totalItems}</p>
							</div>
						</Col>
						<Col xs={12} sm={9}>
							<div className="d-flex float-right">
								<Form.Group controlId="formFilterLimit" title="Limit" className="mr-1">
									<Form.Control
										as="select"
										onChange={(e) => handleChangeFilters("limit", e, "")}
									>
										{limitOptions.map((limit) => {
											return (
												<option key={limit.id} value={limit.value}>
													{limit.label}
												</option>
											);
										})}
									</Form.Control>
								</Form.Group>
								<Pagination>
									<Pagination.First
										onClick={() => handleChangeFilters("page", "", "first")}
										disabled={
											props?.app_versions?.list?.length === 0 || filters.page === 1
										}
									/>
									<Pagination.Prev
										onClick={() => handleChangeFilters("page", "", "back")}
										disabled={
											props?.app_versions?.list?.length === 0 || filters.page === 1
										}
									/>
									<Pagination.Item disabled>
										{props?.app_versions?.totalPages > 0
											? filters.page + " / " + props?.app_versions.totalPages
											: "0 / 0"}
									</Pagination.Item>
									<Pagination.Next
										onClick={() => handleChangeFilters("page", "", "next")}
										disabled={
											props?.app_versions?.list?.length === 0 ||
											filters.page === props?.app_versions?.totalPages ||
											!props?.app_versions?.totalPages
										}
									/>
									<Pagination.Last
										onClick={() => handleChangeFilters("page", "", "last")}
										disabled={
											props?.app_versions?.list?.length === 0 ||
											filters.page === props?.app_versions?.totalPages ||
											!props.app_versions?.totalPages
										}
									/>
								</Pagination>
							</div>
						</Col>
					</Row>
				</TableBodyWidth>
			</CardContainer>

			{/* Create/Edit Modal */}
			<Modal show={showModal} centered backdrop="static">
				<Modal.Header>
					<Modal.Title>Release New Version</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form id="formCreateEdit" onSubmit={(e) => handleSubmitCreateEdit(e)}>
						<Row>
							<Col xs={12} sm={6}>
								<Form.Group controlId="formCreateEditOS">
									<Form.Label>OS</Form.Label>
									<Form.Control
										as="select"
										disabled={modalMode === "edit"}
										defaultValue={selectedOS}
										onChange={(e) => handleChangeSelectedOS(e)}
									>
										{osOptions
											.filter((os) => os.label !== "All OS")
											.map((os) => {
												return (
													<option key={os.id} value={os.value}>
														{os.label}
													</option>
												);
											})}
									</Form.Control>
								</Form.Group>
							</Col>
							<Col xs={12} sm={6}>
								<Form.Group controlId="formCreateEditVersion">
									<Form.Label>Version</Form.Label>
									<Form.Control
										placeholder="Enter app version"
										value={version}
										onChange={(e) => handleChangeVersion(e)}
									/>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => handleShowCloseModal("")}>
						Cancel
					</Button>
					<Button type="submit" onClick={(e) => handleSubmitCreateEdit(e)}>
						Submit
					</Button>
				</Modal.Footer>
			</Modal>

			{/* Toast */}
			<Toast
				className={toastBgColor}
				onClose={() => setShowToast(false)}
				show={showToast}
				delay={3000}
				autohide
				style={{
					position: "fixed",
					top: 70,
					right: 35,
					zIndex: 1041,
				}}
			>
				<Toast.Header closeButton={false}>
					<p className="mr-auto p-2 text-dark">{toastMessage}</p>
				</Toast.Header>
			</Toast>
		</HelpPageWrapper>
	);
};

// style
const HelpPageWrapper = styled.div`
	background-color: #f7f7f7;
	position: relative;
	padding: 30px;
	min-height: 50vh;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	@media (max-width: 989px) {
		padding-top: 70px;
	}
	& > div.row {
		background-color: #fff;
		padding: 30px 20px;
		border-radius: 10px;
		box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
	}
`;

const CardContainer = styled.div`
	background-color: #fff;
	padding: 30px 20px;
	border-radius: 10px;
	box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
`;

const TableBodyWidth = styled.div`
	table tr th {
		white-space: nowrap;
		width: initial;
		vertical-align: middle;
	}

	td {
		vertical-align: middle;
	}
`;

const mapStateToProps = (state) => {
	return {
		app_versions: state.dashboardReducer.app_versions,
		loading: state.globalReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getAllAdminAppVersions: (data) => getAllAdminAppVersions(data, dispatch),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AppVersions);
